import {
    GET_TRANSMISSION_VALIDATOR_REQUEST,
    GET_TRANSMISSION_VALIDATOR_SUCCESS,
    GET_TRANSMISSION_VALIDATOR_FAILURE,
    SET_STATE_TRANSMISSION_VALIDATOR,
    GET_TRANSMISSION_HISTORY_LOGS_REQUEST,
    GET_TRANSMISSION_HISTORY_LOGS_SUCCESS,
    GET_TRANSMISSION_HISTORY_LOGS_FAILURE
} from "../actions/transmissionValidator";
import { buildTransmission, sortTransmission, buildTransmissionHistoryLogs } from "../helpers/tansmissionValidator";

const initialState = {
    fetching: false,
    fetchingHistoyLogs: false,
    transmissions: [],
    historyLogs: [],
    transmission: {},
    totalHistoryLogs: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_TRANSMISSION_VALIDATOR_REQUEST: {
            return {
                ...state,
                fetching: true,
                transmissions: []
            };
        }
        case GET_TRANSMISSION_VALIDATOR_SUCCESS: {


            const wsData = action.payload.transmissions;

            let eventData;
            let vehicleData = {};
            
            if (wsData.data) {
       
                eventData = wsData.data.data?.event || wsData.data.event || wsData.data;
                vehicleData = wsData.data.vehicle || wsData.vehicle || {};
            } else {
                eventData = wsData;
                vehicleData = wsData.vehicle || {};
            }
            
            const transmissionData = {
                event: eventData,
                vehicle: vehicleData
            };

            
            return {
                ...state,
                transmissions: sortTransmission(
                    state.transmissions.concat(buildTransmission(transmissionData))
                )
            };
        }
        case GET_TRANSMISSION_VALIDATOR_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_TRANSMISSION_HISTORY_LOGS_REQUEST: {
            return {
                ...state,
                fetchingHistoyLogs: true
            };
        }
        case GET_TRANSMISSION_HISTORY_LOGS_SUCCESS: {
            return {
                ...state,
                historyLogs: [
                    ...state.historyLogs,
                    ...buildTransmissionHistoryLogs(action.payload.historyLogs)
                ],
                fetchingHistoyLogs: false,
                totalHistoryLogs: action.payload.total || state.totalHistoryLogs
            };
        }
        case GET_TRANSMISSION_HISTORY_LOGS_FAILURE: {
            return {
                ...state,
                fetchingHistoyLogs: false
            };
        }
        case SET_STATE_TRANSMISSION_VALIDATOR: {
            return {
                ...state,
                ...action.payload
            };
        }
        default:
            return state;
    }
};
